import React from 'react';
import BusRatesTable from './BusRatesTable';


const Packages = () => {
 
  return (

<div>
 <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
      <h1>Packages</h1>
    </div>
  </div>
</section>



<BusRatesTable/>

</div>  );
};

export default Packages;
